import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import OceanLayout from "./components/OceanLayout";

/* ADD THESE */
import DisclaimerModal from "./components/DisclaimerModal";
import useDisclaimer from "./components/useDisclaimer";

/* ✅ BACKEND BASE URL (Render) */
const API_BASE =
  process.env.REACT_APP_API_URL ||
  "https://rojgar-boat-backend.onrender.com";

function EmployerRegister() {
  const navigate = useNavigate();

  const { accepted, acceptDisclaimer } = useDisclaimer();

  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    organization: "",
    location: "",
    password: "",
    confirmPassword: "",
  });

  const [message, setMessage] = useState("");

  /* ---------- FORM HANDLING ---------- */
  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  /* ---------- SUBMIT ---------- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!form.password || form.password.length < 6) {
      setMessage("Password must be at least 6 characters.");
      return;
    }

    if (form.password !== form.confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }

    const payload = {
      name: form.name,
      phone: form.phone,
      email: form.email,
      organization: form.organization,
      location: form.location,
      password: form.password,
    };

    try {
      const res = await fetch(`${API_BASE}/api/employers/create`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      /* 🛑 SAFETY: handle non-JSON / error responses */
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "Registration failed");
      }

      const data = await res.json();

      if (data?.error) {
        setMessage(data.error);
        return;
      }

      setMessage("Registration successful! Redirecting to login...");
      setTimeout(() => navigate("/employer-login"), 800);
    } catch (err) {
      setMessage(err.message || "Something went wrong.");
    }
  };

  /* ---------- UI ---------- */
  return (
    <OceanLayout>

      {/* ✅ DISCLAIMER MODAL */}
      {!accepted && (
        <DisclaimerModal onAccept={acceptDisclaimer} />
      )}
      
      {/* ✅ DISABLE UI IF NOT ACCEPTED */}
      <div
        className={`w-full max-w-3xl bg-white/90 backdrop-blur-md shadow-xl rounded-3xl px-8 py-10 border ${
          !accepted ? "pointer-events-none opacity-50" : ""
        }`}
      >
        <h2 className="text-3xl font-extrabold text-center mb-2">
          Employer Registration
        </h2>

        <p className="text-center text-gray-600 mb-8">
          Register to post jobs and manage your applicants.
        </p>

        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
        >
          <div>
            <label className="block text-sm font-medium mb-1">Name</label>
            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              required
              className="w-full rounded-xl border px-3 py-2 focus:ring-2 focus:ring-green-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">
              Phone Number
            </label>
            <input
              name="phone"
              value={form.phone}
              onChange={handleChange}
              required
              className="w-full rounded-xl border px-3 py-2 focus:ring-2 focus:ring-green-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Email</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              className="w-full rounded-xl border px-3 py-2 focus:ring-2 focus:ring-green-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">
              Shop / Organization
            </label>
            <input
              name="organization"
              value={form.organization}
              onChange={handleChange}
              className="w-full rounded-xl border px-3 py-2 focus:ring-2 focus:ring-green-500"
            />
          </div>

          <div className="md:col-span-2">
            <label className="block text-sm font-medium mb-1">
              Location (village / area)
            </label>
            <input
              name="location"
              value={form.location}
              onChange={handleChange}
              className="w-full rounded-xl border px-3 py-2 focus:ring-2 focus:ring-green-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">
              Password
            </label>
            <input
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              required
              className="w-full rounded-xl border px-3 py-2 focus:ring-2 focus:ring-green-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">
              Confirm Password
            </label>
            <input
              type="password"
              name="confirmPassword"
              value={form.confirmPassword}
              onChange={handleChange}
              required
              className="w-full rounded-xl border px-3 py-2 focus:ring-2 focus:ring-green-500"
            />
          </div>

          <div className="md:col-span-2">
            <button
              type="submit"
              className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 rounded-xl transition"
            >
              Register
            </button>

            {/* ✅ DISCLAIMER TEXT */}
            <p className="text-xs text-center mt-3 text-gray-600">
              By registering, you agree to our Terms & Disclaimer
            </p>
            
          </div>
        </form>

        {message && (
          <p className="text-center text-sm mt-4 text-red-500">{message}</p>
        )}

        <p className="mt-6 text-center text-gray-700 text-sm">
          Already registered?{" "}
          <Link
            to="/employer-login"
            className="text-green-700 font-semibold hover:underline"
          >
            Login here
          </Link>
        </p>
      </div>
    </OceanLayout>
  );
}

export default EmployerRegister;








